import { createSelector } from 'reselect';
import { ReduxStore } from '../interfaces/store';

const root = (state: ReduxStore) => state.approvedCountries;

export const approvedCountriesStatusSelector = createSelector(
  root,
  approvedCountries => approvedCountries?.status ?? 'idle'
);

export const approvedCountryCodesSelector = createSelector(
  root,
  approvedCountries => new Set(approvedCountries?.codes ?? [])
);
